// components/CotizadorIframe/CotizadorIframe.tsx
import s from './CotizadorIframe.module.css';
import { CotizadorIframeEntity } from '@/types/model';
import { Button } from '@/components';
import { motion } from 'framer-motion';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { useTranslations } from 'next-intl';

const CotizadorIframe = ({ url, PDF }: CotizadorIframeEntity) => {
  const t = useTranslations('cotizador');
  const urlPDF = `${process.env.NEXT_PUBLIC_UPLOAD_ASSETS}${PDF?.url}`;
  const handleDownload = async () => {
    if (!urlPDF || !urlPDF.endsWith('.pdf')) return;

    try {
      const { data } = await axios.get(urlPDF, { responseType: 'blob' });
      const fileName = 'Disponibilidad.pdf';
      saveAs(data, fileName);
    } catch (error) {
      console.error('Error al descargar el PDF:', error);
    }
  };

  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}>
      <iframe src={url} loading="lazy" title="Cotizador Marevera"></iframe>
      {PDF && <Button label={t('download')} onClick={handleDownload} />}
    </motion.div>
  );
};

export default CotizadorIframe;
